"use strict";
/********************************************************************************
  HxActiveSet.ts

  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxActiveSet = void 0;
var HxNativeInterop_1 = require("./HxNativeInterop");
var HxActiveSetEvent_1 = require("./HxActiveSetEvent");
var HxActorAPIs_1 = require("./HxActorAPIs");
var HxCollection_1 = require("./HxCollection");
var HxCollectionChange_1 = require("./HxCollectionChange");
var HxCollectionStore_1 = require("./HxCollectionStore");
var HxCollectionUpdate_1 = require("./HxCollectionUpdate");
var HxObjectID_1 = require("./HxObjectID");
var HxObjectStore_1 = require("./HxObjectStore");
var HxSessionStore_1 = require("./HxSessionStore");
var HxVirtualizedCollection_1 = require("./HxVirtualizedCollection");
var HxVirtualizedCollectionStore_1 = require("./HxVirtualizedCollectionStore");
var HxVirtualizedTimeCollectionStore_1 = require("./HxVirtualizedTimeCollectionStore");
var HxObjectSerializer_1 = __importDefault(require("./HxObjectSerializer"));
var emptyArray = [];
var HxActiveSet = /** @class */ (function () {
    function HxActiveSet(nativeInterop) {
        var _this = this;
        this.onObjectChanged = function (nativeEvent) {
            var object = _this.deserializeObject(nativeEvent);
            if (object && _this.objectStore.updateObject(object)) {
                var sessionIds = _this.objectStore.getSessionsForObject(object.objectId.getCompactIDString());
                _this.notifications.push({ type: HxActiveSetEvent_1.HxActiveSetEventType.ObjectChanged, object: object, sessionIds: sessionIds });
            }
        };
        this.onCollectionChanged = function (nativeEvent) { return __awaiter(_this, void 0, void 0, function () {
            var update, sessionIds, uniqueSessionIds;
            var _this = this;
            return __generator(this, function (_a) {
                update = this.deserializeCollectionUpdate(nativeEvent);
                if (update) {
                    // Deactivate Object if it is not present in CollectionStore/virtualizedTimeCollectionStore/virtualizedCollectionStore
                    if (!this.collectionStore.hasCollection(update.collectionId) && !this.timeCollectionStore.hasCollection(update.collectionId) && !this.virtualizedCollectionStore.hasCollection(update.collectionId)) {
                        this.nativeInterop.deactivateObject(update.collectionId, update.storageSequenceNumber);
                    }
                    else {
                        sessionIds = [];
                        sessionIds.push.apply(sessionIds, __spread(this.collectionStore.onCollectionChanged(update)));
                        sessionIds.push.apply(sessionIds, __spread(this.timeCollectionStore.onCollectionChanged(update)));
                        sessionIds.push.apply(sessionIds, __spread(this.virtualizedCollectionStore.onCollectionChanged(update)));
                        if (sessionIds.length !== 0) {
                            uniqueSessionIds = __spread(new Set(sessionIds));
                            this.notifications.push({ type: HxActiveSetEvent_1.HxActiveSetEventType.CollectionChanged, update: update, sessionIds: uniqueSessionIds });
                        }
                    }
                    // Deactivate any items which we didn't keep.
                    update.changes.forEach(function (change) {
                        if (change.object && !_this.objectStore.findObject(change.object.objectId)) {
                            _this.nativeInterop.deactivateObject(change.object.objectId, change.object.storageSequenceNumber);
                        }
                    });
                }
                return [2 /*return*/];
            });
        }); };
        this.onObjectDeleted = function (nativeEvent) {
            var jsBlob = JSON.parse(nativeEvent);
            var objectId = new HxObjectID_1.HxObjectID(jsBlob[0]);
            if (!objectId) {
                return;
            }
            var storageSequenceNumber = jsBlob[1];
            var sessionIds = _this.objectStore.onObjectDeleted(objectId, storageSequenceNumber);
            if (sessionIds.length !== 0) {
                _this.notifications.push({ type: HxActiveSetEvent_1.HxActiveSetEventType.ObjectDeleted, sessionIds: sessionIds, objectId: objectId });
            }
        };
        this.onNotificationsBegin = function () {
            _this.notifications = []; // clear out any pending notifications on begin batch
        };
        this.onNotificationsEnd = function () {
            if (_this.notifications.length > 0) {
                _this.notifyEventHandlers(_this.notifications);
            }
        };
        this.onLoadObject = function (blob, sessionId, callback) {
            if (!blob) {
                callback(null);
                return;
            }
            var object = _this.deserializeObject(blob);
            if (_this.objectStore.updateObject(object)) {
                _this.notifyEventHandlers([{ type: HxActiveSetEvent_1.HxActiveSetEventType.ObjectLoaded, sessionIds: [sessionId], object: object }]);
            }
            callback(object);
        };
        this.onLoadCollection = function (result, sessionId, callback) {
            var collection = _this.deserializeCollectionLoadResult(result);
            if (!collection) {
                callback(null);
                return;
            }
            if (_this.collectionStore.onCollectionLoaded(collection)) {
                _this.notifyEventHandlers([{ type: HxActiveSetEvent_1.HxActiveSetEventType.CollectionLoaded, sessionIds: [sessionId], collection: collection }]);
            }
            callback(collection);
        };
        this.onLoadVirtualizedCollection = function (result, sessionId, callback) {
            var collection = _this.deserializeVirtualizedCollectionLoadResult(result);
            if (!collection) {
                callback(null);
                return;
            }
            if (_this.virtualizedCollectionStore.onCollectionLoaded(collection)) {
                _this.notifyEventHandlers([{ type: HxActiveSetEvent_1.HxActiveSetEventType.CollectionLoaded, sessionIds: [sessionId], collection: collection }]);
            }
            callback(_this.virtualizedCollectionStore.findCollection(collection.objectId, sessionId));
        };
        this.onLoadVirtualizedCollectionItems = function (result, sessionId, callback) {
            var loadedItems = _this.deserializeVirtualizedCollectionItemsLoadResult(result);
            if (!loadedItems) {
                callback(null);
                return;
            }
            loadedItems.forEach(function (loadItem) {
                // If the Object exists in ObjectStore, then update it. Otherwise we will still get updates through collection Changed notifications.
                _this.objectStore.updateObject(loadItem);
                // Monarch is using object loaded notifications to populate id map.
                _this.notifyEventHandlers([{ type: HxActiveSetEvent_1.HxActiveSetEventType.ObjectLoaded, sessionIds: [sessionId], object: loadItem }]);
            });
            callback(loadedItems);
        };
        this.onLoadCollectionByTimeRange = function (result, timeRange, sessionId, callback) {
            var collection = _this.deserializeCollectionLoadResult(result);
            if (!collection) {
                callback(null);
                return;
            }
            if (_this.timeCollectionStore.onCollectionLoadedByTimeRange(collection, timeRange, sessionId)) {
                _this.notifyEventHandlers([{ type: HxActiveSetEvent_1.HxActiveSetEventType.CollectionLoaded, sessionIds: [sessionId], collection: collection }]);
            }
            callback(_this.timeCollectionStore.findCollection(collection.objectId, sessionId));
        };
        this.nativeInterop = nativeInterop;
        var initialObjects = this.nativeInterop.getInitialObjects();
        var jsInitialObjects = (typeof initialObjects === "string") ? JSON.parse(initialObjects) : initialObjects;
        var globalCounterSeed = jsInitialObjects['globalCounterSeed'].seed;
        var processIdentifier = jsInitialObjects['jsAppProcessIdentifier'].processId;
        this.actorAPIs = new HxActorAPIs_1.HxActorAPIs(this.nativeInterop, globalCounterSeed, processIdentifier);
        this.eventHandlers = [];
        this.notifications = [];
        this.objectStore = new HxObjectStore_1.HxObjectStore(this.nativeInterop);
        this.collectionStore = new HxCollectionStore_1.HxCollectionStore(this.objectStore, this.nativeInterop);
        this.virtualizedCollectionStore = new HxVirtualizedCollectionStore_1.HxVirtualizedCollectionStore(this.nativeInterop);
        this.timeCollectionStore = new HxVirtualizedTimeCollectionStore_1.HxVirtualizedTimeCollectionStore(this.objectStore, this.nativeInterop);
        this.sessionStore = new HxSessionStore_1.HxSessionStore(this.objectStore, this.collectionStore, this.timeCollectionStore, this.virtualizedCollectionStore);
        this.pinningSessionId = this.createSession();
        this.initialize();
    }
    HxActiveSet.getFakeInstance = function () {
        return new HxActiveSet(HxNativeInterop_1.fakeNativeInterop);
    };
    Object.defineProperty(HxActiveSet, "Instance", {
        get: function () {
            if (!HxActiveSet.instance) {
                throw new Error("initializeOutlookInstance must be called before using any other Hx APIs");
            }
            return HxActiveSet.instance;
        },
        enumerable: false,
        configurable: true
    });
    HxActiveSet.createInstance = function (interopBridge) {
        if (!HxActiveSet.instance) {
            HxActiveSet.instance = new HxActiveSet(new HxNativeInterop_1.HxNativeInterop(interopBridge));
        }
        return HxActiveSet.instance;
    };
    HxActiveSet.prototype.registerHandler = function (handler) {
        this.eventHandlers.push(handler);
    };
    HxActiveSet.prototype.unregisterHandler = function (handler) {
        var index = this.eventHandlers.findIndex(function (item) { return item === handler; });
        if (index !== -1) {
            this.eventHandlers.splice(index, 1);
        }
    };
    HxActiveSet.prototype.registerHealthDelegate = function (delegate) {
        this.nativeInterop.registerHealthDelegate(delegate);
    };
    HxActiveSet.prototype.unregisterHealthDelegate = function (delegate) {
        this.nativeInterop.unregisterHealthDelegate(delegate);
    };
    HxActiveSet.prototype.createSession = function () {
        return this.sessionStore.createSession();
    };
    HxActiveSet.prototype.releaseSession = function (sessionId) {
        this.sessionStore.releaseSession(sessionId);
    };
    HxActiveSet.prototype.getRoot = function (sessionId) {
        return this.getObject(this.rootId, sessionId).then(function (object) { return object; });
    };
    HxActiveSet.prototype.findObject = function (objectId) {
        if (!objectId) {
            return null;
        }
        return this.objectStore.findObject(objectId);
    };
    HxActiveSet.prototype.findObjectByCompactId = function (compactId) {
        if (!compactId)
            return null;
        return this.objectStore.findObjectByCompactId(compactId);
    };
    HxActiveSet.prototype.getObject = function (objectId, sessionId) {
        var _this = this;
        if (objectId.isNil()) {
            return Promise.resolve(null);
        }
        this.sessionStore.addRefObjectInSession(objectId.getCompactIDString(), sessionId);
        var object = this.findObject(objectId);
        if (object) {
            return Promise.resolve(object);
        }
        else {
            return new Promise(function (resolve) { return _this.nativeInterop.loadObject(objectId, function (result) { return _this.onLoadObject(result, sessionId, function (hxObject) { return resolve(hxObject); }); }); });
        }
    };
    HxActiveSet.prototype.getObjectFromHandle = function (handle, type, sessionId) {
        var _this = this;
        var compactId = HxObjectID_1.HxObjectID.getCompactIDFromTypeAndHandle(handle, type);
        this.sessionStore.addRefObjectInSession(compactId, sessionId);
        var object = this.findObjectByCompactId(compactId);
        if (object) {
            return Promise.resolve(object);
        }
        else {
            return new Promise(function (resolve) { return _this.nativeInterop.loadObjectByHandle(handle, type, function (result) { return _this.onLoadObject(result, sessionId, function (hxObject) { return resolve(hxObject); }); }); });
        }
    };
    HxActiveSet.prototype.findCollection = function (collectionId) {
        return collectionId ? this.collectionStore.findCollection(collectionId) : null;
    };
    HxActiveSet.prototype.findCollectionItems = function (collectionId) {
        var collection;
        if (collectionId) {
            collection = this.findCollection(collectionId);
        }
        return collection && collection.items.length > 0 ? collection.items : emptyArray;
    };
    HxActiveSet.prototype.getCollection = function (collectionId, sessionId) {
        var _this = this;
        if (collectionId.isNil()) {
            return Promise.resolve(null);
        }
        this.sessionStore.addRefCollectionInSession(collectionId.getCompactIDString(), sessionId);
        var collection = this.findCollection(collectionId);
        if (collection) {
            return new Promise(function (resolve) { return resolve(collection); });
        }
        else {
            return new Promise(function (resolve) {
                return _this.nativeInterop.loadCollection(collectionId, function (result) { return _this.onLoadCollection(result, sessionId, resolve); });
            });
        }
    };
    HxActiveSet.prototype.findVirtualizedCollection = function (collectionId, sessionId) {
        return this.virtualizedCollectionStore.findCollection(collectionId, sessionId);
    };
    HxActiveSet.prototype.getVirtualizedCollection = function (collectionId, sessionId) {
        var _this = this;
        if (collectionId.isNil()) {
            return Promise.resolve(null);
        }
        this.sessionStore.addVirtualizedCollectionToSession(collectionId.getCompactIDString(), sessionId);
        var collection = this.findVirtualizedCollection(collectionId, sessionId);
        if (collection) {
            return Promise.resolve(collection);
        }
        else {
            return new Promise(function (resolve) {
                return _this.nativeInterop.loadVirtualizedCollection(collectionId, function (result) {
                    return _this.onLoadVirtualizedCollection(result, sessionId, resolve);
                });
            });
        }
    };
    HxActiveSet.prototype.getVirtualizedCollectionItems = function (collectionId, itemIds, sessionId) {
        var _this = this;
        if (itemIds.length === 0) {
            return Promise.resolve(null);
        }
        // Serialize itemIds into string
        var itemIdStrings = itemIds.map(function (itemId) { return itemId.toString(); });
        return new Promise(function (resolve) {
            return _this.nativeInterop.loadVirtualizedCollectionItems(collectionId, itemIdStrings, function (result) {
                return _this.onLoadVirtualizedCollectionItems(result, sessionId, resolve);
            });
        });
    };
    HxActiveSet.prototype.findVirtualizedTimeCollection = function (collectionId, sessionId) {
        return this.timeCollectionStore.findCollection(collectionId, sessionId);
    };
    HxActiveSet.prototype.findVirtualizedTimeCollectionItems = function (collectionId, sessionId) {
        var collection;
        if (collectionId) {
            collection = this.findVirtualizedTimeCollection(collectionId, sessionId);
        }
        return (collection ? collection.items : emptyArray);
    };
    HxActiveSet.prototype.getCollectionByTimeRange = function (collectionId, objectType, sortId, start, end, getItemTimeRange, sessionId) {
        var _this = this;
        if (collectionId.isNil()) {
            return Promise.resolve(null);
        }
        this.sessionStore.addTimeCollectionToSession(collectionId.getCompactIDString(), sessionId);
        var collection = this.findVirtualizedTimeCollection(collectionId, sessionId);
        // todo: more sophisticated optimization here than just checking for equality?
        if (collection && collection.timeRange.start.getTime() === start.getTime() && collection.timeRange.end.getTime() === end.getTime()) {
            return Promise.resolve(collection);
        }
        else {
            var timeRange_1 = { start: new Date(start), end: new Date(end) };
            this.timeCollectionStore.ensureCollection(collectionId, timeRange_1, objectType, getItemTimeRange, sessionId, this);
            return new Promise(function (resolve) {
                return _this.nativeInterop.loadCollectionByTimeRange(collectionId, sortId, start, end, function (result) {
                    return _this.onLoadCollectionByTimeRange(result, timeRange_1, sessionId, resolve);
                });
            });
        }
    };
    HxActiveSet.prototype.initialize = function () {
        var _this = this;
        this.nativeInterop.setEventHandler(this);
        var initialObjects = this.nativeInterop.getInitialObjects();
        var jsInitialObjects = (typeof initialObjects === "string") ? JSON.parse(initialObjects) : initialObjects;
        var jsNamedObjects = jsInitialObjects['namedObjectIDs'];
        this.rootId = new HxObjectID_1.HxObjectID(jsNamedObjects['Root']);
        // Pin initial objects and collections in active set.
        var jsObjects = jsInitialObjects['objects'];
        jsObjects.forEach(function (jsObject) {
            var obj = HxObjectSerializer_1.default.deserializeJsonObject(jsObject, _this);
            _this.sessionStore.addRefObjectInSession(obj.objectId.getCompactIDString(), _this.pinningSessionId);
            _this.objectStore.updateObject(obj);
        });
        var jsCollections = jsInitialObjects['collections'];
        jsCollections.forEach(function (jsCollection) {
            var collection = _this.deserializeCollectionLoadResultFromJsonObjects(jsCollection);
            if (collection) {
                _this.sessionStore.addRefCollectionInSession(collection.objectId.getCompactIDString(), _this.pinningSessionId);
                _this.collectionStore.onCollectionLoaded(collection);
            }
        });
        // Tell HxCore that the ActiveSet has been initialized and our event handler is hooked up, so any pending notifications can be processed now
        this.nativeInterop.connectActiveSet();
    };
    HxActiveSet.prototype.deserializeObject = function (blob) {
        var jsObject = JSON.parse(blob);
        return HxObjectSerializer_1.default.deserializeJsonObject(jsObject, this);
    };
    HxActiveSet.prototype.deserializeCollectionLoadResult = function (result) {
        if (!result) {
            return null;
        }
        var jsResult = JSON.parse(result);
        return this.deserializeCollectionLoadResultFromJsonObjects(jsResult);
    };
    HxActiveSet.prototype.deserializeCollectionLoadResultFromJsonObjects = function (jsResult) {
        var e_1, _a;
        var collectionId = new HxObjectID_1.HxObjectID(jsResult[0]);
        var collectionType = jsResult[1];
        var storageSequenceNumber = jsResult[2];
        var objArray = jsResult[3];
        var items = [];
        try {
            for (var objArray_1 = __values(objArray), objArray_1_1 = objArray_1.next(); !objArray_1_1.done; objArray_1_1 = objArray_1.next()) {
                var obj = objArray_1_1.value;
                var hxObject = HxObjectSerializer_1.default.deserializeJsonObject(obj, this);
                items.push(hxObject);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (objArray_1_1 && !objArray_1_1.done && (_a = objArray_1.return)) _a.call(objArray_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return new HxCollection_1.HxCollection(collectionId, collectionType, items, storageSequenceNumber, this);
    };
    HxActiveSet.prototype.deserializeVirtualizedCollectionLoadResult = function (result) {
        if (!result) {
            return null;
        }
        var jsResult = JSON.parse(result);
        return this.deserializeVirtualizedCollectionLoadResultFromJsonObjects(jsResult);
    };
    HxActiveSet.prototype.deserializeVirtualizedCollectionLoadResultFromJsonObjects = function (jsResult) {
        // Result is shaped as such: ["collectionId", "collectionType", "storageSequenceNumber", ["itemId1", ...]]
        var collectionId = new HxObjectID_1.HxObjectID(jsResult[0]);
        var collectionType = jsResult[1];
        var storageSequenceNumber = jsResult[2];
        // jsResult[3] is an array of Strings. Converting them to an array of HxObjectID.
        var itemIds = jsResult[3].map(function (item) { return new HxObjectID_1.HxObjectID(item); });
        return new HxVirtualizedCollection_1.HxVirtualizedCollection(collectionId, collectionType, itemIds, storageSequenceNumber, this /* activeSet */);
    };
    HxActiveSet.prototype.deserializeVirtualizedCollectionItemsLoadResult = function (result) {
        var e_2, _a;
        if (!result) {
            return null;
        }
        // Result is sent in this form hence get only the objects
        // ["collectionId", "collectionType", "storageSequenceNumber", ["object1", ...]]
        var objects = [];
        var objArray = JSON.parse(result)[3];
        try {
            for (var objArray_2 = __values(objArray), objArray_2_1 = objArray_2.next(); !objArray_2_1.done; objArray_2_1 = objArray_2.next()) {
                var obj = objArray_2_1.value;
                objects.push(HxObjectSerializer_1.default.deserializeJsonObject(obj, this));
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (objArray_2_1 && !objArray_2_1.done && (_a = objArray_2.return)) _a.call(objArray_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return objects;
    };
    HxActiveSet.prototype.deserializeCollectionChange = function (change) {
        var changeType = change[0];
        var index = +change[1];
        var hxObject = undefined;
        var itemId = undefined;
        switch (changeType) {
            case HxCollectionChange_1.HxCollectionChangeType.ItemCreated:
            case HxCollectionChange_1.HxCollectionChangeType.ItemChanged:
            case HxCollectionChange_1.HxCollectionChangeType.ItemRemoved:
                hxObject = HxObjectSerializer_1.default.deserializeJsonObject(change[2], this);
                itemId = hxObject.objectId;
                break;
            default:
                throw new RangeError();
        }
        return new HxCollectionChange_1.HxCollectionChange(changeType, index, itemId, hxObject);
    };
    HxActiveSet.prototype.deserializeCollectionUpdate = function (blob) {
        var e_3, _a;
        var jsBlob = JSON.parse(blob);
        var collectionId = jsBlob[0];
        var storageSequenceNumber = jsBlob[1];
        var collectionChanges = jsBlob[2];
        var changes = new Array();
        try {
            for (var collectionChanges_1 = __values(collectionChanges), collectionChanges_1_1 = collectionChanges_1.next(); !collectionChanges_1_1.done; collectionChanges_1_1 = collectionChanges_1.next()) {
                var collectionChange = collectionChanges_1_1.value;
                var hxCollectionChange = this.deserializeCollectionChange(collectionChange);
                changes.push(hxCollectionChange);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (collectionChanges_1_1 && !collectionChanges_1_1.done && (_a = collectionChanges_1.return)) _a.call(collectionChanges_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        // todo: Assert collectionId is not nil
        return new HxCollectionUpdate_1.HxCollectionUpdate(new HxObjectID_1.HxObjectID(collectionId), changes, storageSequenceNumber);
    };
    HxActiveSet.prototype.notifyEventHandlers = function (events) {
        this.eventHandlers.forEach(function (handler) { return handler.onActiveSetChanged(events); });
    };
    return HxActiveSet;
}());
exports.HxActiveSet = HxActiveSet;
exports.default = HxActiveSet;
